import { createContext } from 'react';

const activoContext = createContext();

export default activoContext;